/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offers_SubscribeInputs */

const en_offers_subscribe = /** @type {(inputs: Offers_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe`)
};

const pl_offers_subscribe = /** @type {(inputs: Offers_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrybuj`)
};

/**
* | output |
* | --- |
* | "Subscribe" |
*
* @param {Offers_SubscribeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offers_subscribe = /** @type {((inputs?: Offers_SubscribeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offers_SubscribeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offers_subscribe(inputs)
	return en_offers_subscribe(inputs)
});